module.exports = __webpack_public_path__ + "static/media/web.ee4e1821.png";